import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import * as dateFns from "date-fns";
import moment from "moment";
import { HeaderFilter } from "../../../../header-filter/header-filter.component";
const localizer = momentLocalizer(moment);
export let navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE',
}


class CustomToolbar extends Component {   
    render() { 
        const dropdownList= ["Item 1", "Item 2", "Item 3"]      
        let { localizer: { messages }, label, onView, views } = this.props
        return(
            <div className="rbc-toolbar">
               <div className="rbx-toolbar-left-container">
                <span className="rbc-btn-group">
                        <button type="button" onClick={this.navigate.bind(null, navigate.PREVIOUS)}>&#60;</button>
                    </span>
                    <span className="rbc-toolbar-label">{label}</span>
                    <span className="rbc-btn-group">
                        <button type="button" onClick={this.navigate.bind(null, navigate.NEXT)}>&#62;</button>
                    </span>
                    {views.map(view => (
                    <button
                        key={view}
                        type="button"
                        onClick={() => onView(view)}
                    >
                        {view}
                    </button>
                    ))}
               </div>
               <HeaderFilter enableDatePicker={true} enableDropdown={true} dropdownItem={dropdownList} enableExportExcel={false} btnAddTitle="Add Contract" enableAddBtn={false} enableUploadBtn={false} haveTab={false} />
            </div>
        )
    }
    navigate = action => {
        this.props.onNavigate(action)
    }
  }

  export class CalendarScheduler extends Component {
    constructor(props) {
        super(props);
        const now = new Date();
        const events = [
          {
            id: 0,
            title: "All Day Event very long title",
            allDay: true,
            start: new Date(2019, 6, 0),
            end: new Date(2019, 6, 1),  
             
          },
          {
            id: 1,
            title: "Long Event",
            start: new Date(2019, 3, 7),
            end: new Date(2019, 3, 10),   
             
          },
          {
            id: 2,
            title: "Overdue",
            start: now,
            end: now,          
          },
          {
            id: 2,
            title: "Expected",
            start: now,
            end: now,    
                  
          },
          {
            id: 3,
            title: "Received",
            start: now,
            end: now,  
               
          }
        ];
        this.state = { events };       
      }
    
   
      componentDidMount() {         
        setInterval(() => {
          this.eventsContent()
        }, 1);  
      }

    
      eventsContent() {
          const eventList=document.querySelectorAll('.rbc-event .rbc-event-content');
          const rbcTimeView=document.querySelectorAll('.rbc-time-view .rbc-time-column');
          if(eventList.length!==0) {
            for (var x=0; x < eventList.length; x++) 
            {            
              if(eventList[x].innerText==="Overdue") {
                eventList[x].parentNode.classList.add('red')
              }
              if(eventList[x].innerText==="Expected") {
                eventList[x].parentNode.classList.add('yellow')
              }
              if(eventList[x].innerText==="Received") {
                eventList[x].parentNode.classList.add('green')
              }
             
            }
          }
          if(rbcTimeView.length<3 && rbcTimeView.length!==0) {
            rbcTimeView[1].parentNode.classList.add('rbc-date-view')
          }

          
      }
    
      render() {
     
        return (
          <div className="calendar-container">
            <Calendar
              events={this.state.events}
            
              // formats={formats}
              startAccessor="start"           
              components={{
                toolbar: CustomToolbar,
                  
              }}
              views={{
                month: true,
                week: true,
                day: true,
              }}
              defaultView='month'
              endAccessor="end"
              defaultDate={moment().toDate()}
              localizer={localizer}
            />
           
          </div>
        );
      }
  }